module.exports = __webpack_public_path__ + "0b6be87e4c6252ec43f81b78aa1dedef.eot";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/proxima-nova/2E6388_0_0.eot
// module id = 206
// module chunks = 0